import { sound } from "@pixi/sound";
import { currentBackgorundMusic, setIsMusicBtnOnGlobal, setIsSoundBtnOnGlobal } from "../config/GlobalVariableConfig";
import { casinoEventEmitter } from "./CasinoChannelHandler";

export class BurgerMenuManager {
    constructor() {
        // Subscribe to events
        casinoEventEmitter.on('enableSound', this.enableSound);
        casinoEventEmitter.on('muteSound', this.muteSound);
        casinoEventEmitter.on('enableMusic', this.enableMusic);
        casinoEventEmitter.on('muteMusic', this.muteMusic);

    }

    private enableSound = async () => {
        console.log("Sound enabled");

        const ctx = sound.context.audioContext;

        try {
            if (ctx.state !== "running") {
                await ctx.resume();
                console.log("AudioContext:", ctx.state);
            }
        } catch (e) {
            console.error("Failed to resume AudioContext", e);
        }

        sound.unmuteAll();
        sound.resumeAll();

        setIsSoundBtnOnGlobal(true);
    };

    private muteSound = () => {
        console.log("Sound muted");

        sound.muteAll();
        sound.pauseAll();

        setIsSoundBtnOnGlobal(false);
    };

    private enableMusic = () => {
        console.log("Music enabled");
        setIsMusicBtnOnGlobal(true);
        if (currentBackgorundMusic) {
            currentBackgorundMusic.muted = false;
            // currentBackgorundMusic.volume = currentBackgorundMusicVolume;
        }
    };

    private muteMusic = () => {
        console.log("Music muted");
        setIsMusicBtnOnGlobal(false);
        if (currentBackgorundMusic) {
            // currentBackgorundMusic.volume = 0;
            currentBackgorundMusic.muted = true;
        }
    };

}